module.exports = __webpack_public_path__ + "assets/0cdf3fcc31eca4f411cdfba2c1176809.png";